export const sliderData = [
  {
    title: "Portfolio Site Refresh - Feb 2023",
    desc: "A refresh of my portfolio site. Built with React and Styled components Hosted on Netlify. I've added a light and dark mode toggle, a new design, and have updated my experience and projects.",
    image: require("../../videos/portfoliosite.gif"),
    type: "img",
    github: "https://github.com/mplowey28/portfolio-site",
    demo: "https://matthewplowey.com",
  },
  {
    title: "CryptoChartsPro - Jan 2021",
    desc: "A responsive web app that allows user to monitor the changing cryptocurrency market. Built with React, Tailwind, and Chart.js. Hosted on Netlify.",
    image: require("../../assests/images/cryptocharts.png"),
    type: "img",
    github: "https://github.com/mplowey28/CryptoChartsPro",
    demo: "https://cryptochartspro.com/",
  },
  {
    title: "Portfolio Site - Oct 2020",
    desc: "My personal portfolio site. A responsive site made with React and Styled Components. Hosted on Netlify.",
    image: require("../../assests/images/portfolio.png"),
    type: "img",
    github: "https://github.com/mplowey28/portfolio-site",
    demo: "https://matthewplowey.com",
  },
  {
    title: "Weather App - Oct 2020",
    desc: "A React app built with TypeScript using OpenWeatherMap API.",
    image: require("../../videos/weather.mp4"),
    github: "https://github.com/mplowey28/weather-app-typescript-react-",
    demo: "https://flamboyant-blackwell-f8f8c1.netlify.app",
  },
  {
    title: "Tappy - Sept 2020",
    desc: "A React Native app with Firebase user authenication developed for Tappy during a two week sprint. The app allows user to send vouchers for drinks, coffee, and pastries for local resturants to their friends. Features a shopping cart feature built using Redux and payments handled by Stripe.",
    image: require("../../videos/tappy_gif.gif"),
    type: "img",
    github: "https://github.com/mplowey28/TappyPublic",
  },
  {
    title: "TrashTagger - July 2020",
    desc: "A React Native app with login authenication and Google image moderation that allows users to take geotagged photos of areas that are heavily littered. The app uses Google Maps API to display the geotagged photos so other user can go to the tagged sites and clean them. Once the user has cleaned a particular site, the user can mark the site as done, they will receive points for cleaning the site, and the site will be marked as completed on the map.",
    image: require("../../assests/images/trashtagger_logo.png"),
    type: "img",
    github: "https://github.com/mplowey28/TrashTagger",
    demo: "https://vimeo.com/472432541",
  },
  {
    title: "A bird's eye view - July 2020",
    desc: "A React web app I made during a hackday. Users can input a city or major site in the world and the app will return the latest Landsat satellite image of the user's input location.",
    image: require("../../videos/bev.mp4"),
    github: "https://github.com/mplowey28/a-birds-eye-view",
  },
];
